import { create } from 'zustand';
import { IStoreAction, IStoreState } from '@/common/models/IStore';
import { ENDPOINT_CURRENT_USER } from '@/common/constants';
import { HttpApi } from '@/common/http';
import { IUser } from '@/common/models';

const httpApi = new HttpApi();

const useStore = create<IStoreState & IStoreAction>((set) => ({
  user: null,
  scaleActive: false,
  incomingScaleActive: false,
  outgoingScaleActive: false,
  fetchUser: async () => {
    const response = await httpApi.get<IUser>(ENDPOINT_CURRENT_USER);
    set({ user: response });
  },
  setScaleActive: (value) =>
    set((state) => ({
      scaleActive: value,
    })),
  setIncomingScaleActive: (value) =>
    set((state) => ({
      incomingScaleActive: value,
    })),
  setOutgoingScaleActive: (value) =>
    set((state) => ({
      outgoingScaleActive: value,
    })),
}));

export default useStore;
